import { render } from "./LevelList.vue?vue&type=template&id=83f30c98&scoped=true&ts=true"
import script from "./LevelList.vue?vue&type=script&lang=ts"
export * from "./LevelList.vue?vue&type=script&lang=ts"

import "./LevelList.vue?vue&type=style&index=0&id=83f30c98&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f30c98"]])

export default __exports__